import templateUrl from 'emun.salesrep/territory-manager/territory/territory-list.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
//import RegionPrompt from "emun.salesrep/territory-manager/region/region-prompt";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";

class TerritoryListController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.query = new AutoQuery({
			url: 'QueryTerritories.json',
			autoLoad: true,
			hideLeftNav: true,
			orderBy: "Name",
			sortOptions: {
				'Name': 'Name: A to Z',
				'-Name': 'Name: Z to A',
			}
		});
		let $rootScope = resolve("$rootScope");
		$rootScope.$on("territorySaved", () => $ctrl.query.load(true));
    }
	//create() {
	//	const $ctrl = this;
	//	RegionPrompt.open({ region: "", regionId: "" });
	//}
	create() {
		const $ctrl = this;
		// $ctrl.$state.transitionTo("territory", { territoryId: 'create' });
		modals.prompt('Territory Name...').result.then(name => {
			$ctrl.bus.send("CreateTerritory.json", {
				id: name,
				name: name 
			})
			.then(function (res) {
				$ctrl.$state.transitionTo("territory", { territoryId: res.data.id });
			});
		});


	}

	//edit(region) {
	//	const $ctrl = this;
	//	RegionPrompt.open({ region: region, regionId: region.id });
	//}

	delete(territory) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure you want to delete " + territory.name, "Delete Territory?")
			.result.then(function () {
				//console.info("delete it");
				$ctrl.bus
					.send("DeleteTerritory.json", territory)
					.then(function () {
						return $ctrl.query.load(true);
					})
					.catch(

					);
			});
	}
}

let TerritoryList = {
	controller: TerritoryListController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
}

export default TerritoryList;
